import { create } from 'zustand';

const RABBIT_HOLE_KEY = 'erh_rabbit_hole_state';

interface ThemeState {
  hasEnteredRabbitHole: boolean;
  isTransitioning: boolean;
  isLoginTransitioning: boolean;

  initialize: () => void;
  enterRabbitHole: () => void;
  setTransitioning: (transitioning: boolean) => void;
  setLoginTransitioning: (transitioning: boolean) => void;
  resetRabbitHole: () => void;
}

export const useThemeStore = create<ThemeState>((set) => ({
  hasEnteredRabbitHole: false,
  isTransitioning: false,
  isLoginTransitioning: false,

  initialize: () => {
    if (typeof window === 'undefined') return;
    const saved = localStorage.getItem(RABBIT_HOLE_KEY);
    if (saved === 'true') {
      set({ hasEnteredRabbitHole: true });
    }
  },

  enterRabbitHole: () => {
    if (typeof window === 'undefined') return;
    localStorage.setItem(RABBIT_HOLE_KEY, 'true');
    set({ hasEnteredRabbitHole: true, isTransitioning: false });
  },

  setTransitioning: (transitioning: boolean) => {
    set({ isTransitioning: transitioning });
  },

  setLoginTransitioning: (transitioning: boolean) => {
    set({ isLoginTransitioning: transitioning });
  },

  resetRabbitHole: () => {
    if (typeof window === 'undefined') return;
    localStorage.removeItem(RABBIT_HOLE_KEY);
    set({ hasEnteredRabbitHole: false, isTransitioning: false });
  },
}));
